module.exports = __webpack_public_path__ + "img/ikon_hummer.1d2ded82.svg";